import { getQBankStructureLevelLabelByCategory } from '@exam-management/common/utils';
import { findNextEnabledLevel, type QBankStructureLevel } from '@exam-management/qbs-provider';

import type { DisplayQBankStructureLevelItem } from './types';

export function findLevelItemParentById(
  items: DisplayQBankStructureLevelItem[],
  parentId: string,
): DisplayQBankStructureLevelItem | null {
  for (const item of items) {
    if (item.children) {
      const parent = findLevelItemParentById(item.children, parentId);
      if (parent) {
        return parent;
      }
    }

    if (item.id === parentId) {
      return item;
    }
  }

  return null;
}

export function findNextLevelCategory(levels: QBankStructureLevel[], currentLevelId: string) {
  const nextLevel = findNextEnabledLevel(levels, currentLevelId);
  if (!nextLevel) {
    return { label: null, category: null };
  }
  return {
    label: getQBankStructureLevelLabelByCategory(nextLevel.category),
    category: nextLevel.category,
  };
}
